// import './RegistrationForm.scss';

import * as React from 'react';
import { Button, Input, Divider, Checkbox, notification, Form, FormInstance } from 'antd';
import { ReactSVG } from 'react-svg';
import { startCase } from 'lodash';

import UserApi from '../../../api-services/user-api.service';
import DocumentModal from '../../modals/document-modal/DocumentModal';

const facebook = require('@mdi/svg/svg/facebook.svg');


interface RegistrationFormProps {
  loginClicked: () => void;
  googleSignInUrl: string;
  fbSignInUrl: string;
  csrfToken: string;
}

interface RegistrationFormState {
  registeringUser: boolean;
  documentModalVisible: boolean;
}


class RegistrationForm extends React.Component<RegistrationFormProps, RegistrationFormState> {
  
  registrationForm = React.createRef<FormInstance>();
  
  
  componentDidMount(): void {
    this.setState({
      registeringUser: false
    });
  }
  
  
  /**
   * User will be automatically logged in after a successful registration.
   * Redirect user to profile page after registration.
   */
  registerUser(formEvent: any): void {
    const userApi = new UserApi;
    const payload = {
      email: formEvent.email,
      password: formEvent.password,
      confirmPassword: formEvent.confirmPassword,
      firstName: formEvent.firstName,
      lastName: formEvent.lastName,
      specialOffers: formEvent.specialOffers
    };

    this.setState({ registeringUser: true });

    userApi.registerUser(payload)
    .then(registerUserResponse => {
      notification.success({ message: 'User registration successful.', className: 'antd-mod center' });
      window.location.href = '/profile-setup';
    })
    .catch(error => {
      console.error(error);

      // CONSIDER creating a helper method for parsing the error messages from error response.
      const errorKeys = Object.keys(error?.response?.data?.errors);
      errorKeys.forEach(errorKeyName => {
        const errorMessage = `${startCase(errorKeyName)} ${error?.response?.data?.errors[errorKeyName]}`;
        notification.error({ message: errorMessage, className: 'antd-mod center' });
      });
      
    })
    .finally(() => {
      this.setState({ registeringUser: false });
    });
  }
  
  
  render() {
    return (
      <div className="RegistrationForm">
        <DocumentModal filePath={'/documents/users-terms-of-use.pdf'} visible={this.state?.documentModalVisible} closed={() => { this.setState({ documentModalVisible: false }) }}></DocumentModal>
        
        <Form ref={this.registrationForm} onFinish={(event) => { this.registerUser(event) }} className="registration-form">
          <div className="header">
            <div className="title typo-headline">Register</div>
            <div className="login-link typo-subheading-1 typo-bold" onClick={() => { this.props?.loginClicked() }}>Log In</div>
          </div>

          <div className="name-row">
            <Form.Item name="firstName" rules={[{ required: true, message: 'First name is required' }]}>
              <Input placeholder="First Name" />  
            </Form.Item>

            <Form.Item name="lastName" rules={[{ required: true, message: 'Last name is required' }]}>
              <Input placeholder="Last Name" />
            </Form.Item>
          </div>
          
          <Form.Item name="email" rules={[{ type: 'email', message: 'The input is not valid E-mail!' }, { required: true, message: 'Email is required' }]}>
            <Input placeholder="Email Address" />
          </Form.Item>
          
          <Form.Item name="password" rules={[{ required: true, message: 'Password is required' },  {min: 6, message: "Password must be at least 6 characters long"}]}>
            <Input.Password placeholder="Password" />
          </Form.Item>

          <Form.Item name="confirmPassword" 
              rules={[{ required: true, message: 'Confirm Password is required' },{ min: 6, message: "Password must be at least 6 characters long"} ,  
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Does not match with password'));
                },
            })]}>
            <Input.Password placeholder="Confirm Password" />
          </Form.Item>
          
          <Form.Item name="specialOffers" valuePropName="checked">
            <Checkbox className="special-offers antd-mod">I want to receive exclusive updates and special offers from Bridepay and its partners</Checkbox>
          </Form.Item>

          <Button loading={this.state?.registeringUser} className="continue" size="large" htmlType="submit">Continue</Button>
          
          <div className="terms-and-conditions">
            <div>By registering, I agree to the Bridepay's</div>
            <div className="link" onClick={() => { this.setState({ documentModalVisible: true }) }}>Terms of Use</div>
          </div>
        </Form>
        
        <Divider plain>or continue with</Divider>
        
        <div className="other-logins">
          <form action={this.props?.fbSignInUrl} method="post" id="fbLoginForm">
            <input type="hidden" name="authenticity_token" value={this.props?.csrfToken}></input>
            <Button htmlType="submit" className="facebook typo-bold-2 typo-body"  size="large"> 
              <ReactSVG src={facebook} />  
              Facebook
            </Button>
          </form>

          <form action={this.props?.googleSignInUrl} method="post" id="googleLoginForm">
            <input type="hidden" name="authenticity_token" value={this.props?.csrfToken}></input>
            <Button htmlType="submit" className="google typo-bold-2 typo-body"  size="large"> 
              <img src="/images/google-logo.png" alt="Google Icon" />
              Google
            </Button>
          </form>
        </div>

        <div className="login-link">
          Already have an account?
          &nbsp;
          <a onClick={() => { this.props?.loginClicked() }}>Log In</a>
        </div>
      </div>
    );
  }
  
  
}




export default RegistrationForm;
